import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.tsx';
import { whenIdle } from './lib/idle.ts';
// Montserrat (OFL-1.1, Fontsource) — tipografia do material Anashopping; servida localmente, funciona offline.
import '@fontsource-variable/montserrat';
import './styles.css';

// App shell is cached for offline use; API responses are never cached by the service worker.
// A new version is applied only when the user asks (UpdateBanner): never a reload under an unsaved form.
// Registered at once, on purpose. Deferred until after load (tried for the phone's bandwidth), the registration fell
// in the middle of a sign-in; in WebKit the session cookie rotated by the second factor was then lost and the user
// signed out (4 of 4 attempts; 0 of 4 when registered at load — docs/reviews/RESPONSIVE_TEST_REPORT.md).
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    (window as Window & { __anaUpdate?: () => void }).__anaUpdate = () => void updateSW(true);
    window.dispatchEvent(new Event('ana:update-ready'));
  },
});

// Field Web Vitals (anonymous) only from production builds: the dev server's HMR would distort them. Loaded as a
// separate chunk when the browser is idle, off the first screen's critical path; web-vitals reads the buffered
// performance entries, so the load-time metrics (LCP, FCP, TTFB, CLS) are still complete.
if (import.meta.env.PROD) whenIdle(() => void import('./lib/vitals.ts').then((m) => m.startVitals()));

const root = document.getElementById('root');
if (!root) throw new Error('#root ausente');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
